import { Network } from "../services/NetworkApi";

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}

export const getAdminType = (isSuperAdmin: boolean) =>
  isSuperAdmin ? "super admin" : "regular admin";

export const pushNetworkDetailsToDataLayer = (
  portfolioName: string | undefined,
  networkName: string | undefined,
  adminType: string
) => {
  try {
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: 'ga_user_properties',
      portfolio_name: portfolioName || "unknown",
      network_name: networkName || "unknown",
      admin_type: adminType,
    });
  } catch (error) {
    // Silently fail if Google Tag Manager is not available.
  }
};

export const updateDataLayerOnNetworkChange = (
  selectedNetwork: Network | undefined,
  isSuperAdmin: boolean
) => {
  if (!selectedNetwork) {
    return;
  }

  const portfolioName = selectedNetwork.portfolio?.name;
  const networkName = selectedNetwork.l1Name;
  const adminType = getAdminType(isSuperAdmin);

  pushNetworkDetailsToDataLayer(portfolioName, networkName, adminType);
};
